import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_IddServiceNote = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_IddServiceNote' className='file-pdf-document'>

            <div className='file-template'>

                <p>
                    <center> <h3> IDD Service Note </h3> </center>
                </p> 

                
                <p className='w-750'>
                    <span className='eleHeader'>Person's Activity:</span>
                    <span className='small'>(Who, What, When, Where, How, Why)</span>
                    <textarea id='txtPersonActivity' name='txtPersonActivity' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Staff's Activity:</span>
                    <span className='small'>(Who, What, When, Where, How, Why)</span>
                    <textarea id='txtPersonActivity' name='txtPersonActivity' className='add-only'></textarea>
                </p> 
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Appropriately Licensed Practitioner & Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Provider must record the person's activities and the support activities provided by staff, Descrive choices offered. Address outcomes supported:</span>
                    <span className='small'>(Who, What, When, Where, How, Why)</span>
                    <textarea id='txtDescriveChoicesOffered' name='txtDescriveChoicesOffered' className='add-only'></textarea>
                </p> 
                <p className='w-750'>
                    <span className='eleHeader'>Community Integration Location(s):</span> 
                    <textarea id='txtCommunityIntegrationLocation' name='txtCommunityIntegrationLocation' className='add-only'></textarea>
                </p> 
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Staff Signature/Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <center> (Applies to In Home Respite or Home and Community Support Service Only.) </center>
                            </td> 
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Person/Responsible party Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>





            </div>
        </form>

    )
}







